import * as React from "react";
import MuiIconButton, { MuiIconButtonProps } from "components/MuiExtras/MuiIconButton";
import IconNotify from "components/Icons/IconNotify";

interface IProps {
    active: boolean;
    titleActive?: string;
    titleInactive?: string;
}

const IconButtonNotify: React.FC<IProps & Omit<MuiIconButtonProps, "title">> = (props) => {
    const { active, titleActive, titleInactive, ...rest } = props;
    return (
        <MuiIconButton
            {...rest}
            title={active ? titleActive : titleInactive}
        >
            <IconNotify active={active} />
        </MuiIconButton>
    );
}

export default IconButtonNotify;
